import styled from 'styled-components'

export const SetFieldWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;

  & > div {
    flex: 1;
  }

  & > div:first-child {
    margin-right: 16px;
    max-width: 238px;
  }
`
